module.exports = __webpack_public_path__ + "img/files-white.bc78869c.svg";